/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function LeisDeNewton() {
  return (
    <PaginasEspecificas posicao="12" endereco="/fisica" materia="Física" />
  );
}

export default LeisDeNewton;
